import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { columnas } from "../../Constantes/constantesColumnasTablas"
import { selectContract } from "../../redux/contract/selectors"
import { clearFactoryCases, removeAllMasterDetailExpandedRows, removeMasterDetailExpandedRow, setFactoryTableSortSettings, setMasterDetailExpandedRow } from "../../redux/factoryCases/factoryCasesSlice"
import { selectFactoryCases, selectFactoryCasesLoading, selectFactoryCasesTableSortOptions } from "../../redux/factoryCases/selectors"
import { getFactoryCasesByPlate } from "../../redux/factoryCases/thunks"
import { Comment } from "../common/Comment"
import Table from "../table/Table"


function processComments(data){
    return(
        <div className="datagrid-comment-container">
        {data.data.data.comments.map((e, i)=>
        <Comment key={`${data.processId}-comment-${i}`} message={e} showCommentInfo={false}/>)}
       </div>
        )
}

function FactoryCases(props){
    const dispatch = useDispatch();
    const contract = useSelector(selectContract);
    const factoryCases = useSelector(selectFactoryCases)
    const factoryCasesLoading = useSelector(selectFactoryCasesLoading);
    const sortOptions = useSelector(selectFactoryCasesTableSortOptions);

    useEffect(()=>{
        if(contract){
            if(contract.plate){
                dispatch(getFactoryCasesByPlate({query: `?plate=${contract.plate}`}))
            } else {
                dispatch(clearFactoryCases())
            }
        }
    },[contract])

    function saveExpandedRow(processId){
        dispatch(setMasterDetailExpandedRow(processId))
    }

    function removeExpandedRow(processId){
        dispatch(removeMasterDetailExpandedRow(processId))
    }

    function removeAllExpandedRows(){
        dispatch(removeAllMasterDetailExpandedRows())
    }

    function handleCellClick (e) {

        if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons") && e.column.allowSorting) {
            let column = e.column.dataField;
            let sortOrder = e.column.sortOrder;
            dispatch(setFactoryTableSortSettings({columna: column, orderAsc: sortOrder}))
        }
    }


    return(
        <div style={{position: "relative"}}>
            <Table 
                enableSorting={true} 
                type={"CasosFabrica"} 
                datasource={factoryCasesLoading === "loading" ? [] : factoryCases} 
                columnasTabla={columnas["CasosFabrica"]} 
                master 
                filter={sortOptions}
                handleCellClick={handleCellClick}
                loading={factoryCasesLoading}
                masterDetail={processComments}
                onRowExpanding={(e)=>saveExpandedRow(e.key.processId)}
                onRowCollapsed={(e)=>removeExpandedRow(e.key.processId)}
                onDisposing={removeAllExpandedRows}
                />
        </div>
    )
}

export {FactoryCases}

